import type { ComponentProps } from 'react';
import type { DetectedInitiative } from '@xavior/contracts';
import { makeInitiativesRenderSmartStep } from './InitiativesReveal';
import type { RecipeRunner } from './RecipeRunner';

export function shouldUseRecipeOnboarding(args: {
  onboardingComplete: boolean;
}): boolean {
  return !args.onboardingComplete;
}

type RenderSmartStep = NonNullable<
  ComponentProps<typeof RecipeRunner>['renderSmartStep']
>;

/**
 * Pick the `RecipeRunner.renderSmartStep` for a recipe. Only the `initiatives`
 * recipe streams its `gate`/`reveal` steps; every other recipe returns
 * `undefined`, so its smart steps degrade to their `safeFallback` (the existing
 * framework behavior). Wiring this here keeps the mount site recipe-agnostic.
 */
export function renderSmartStepForRecipe(args: {
  recipeKey: string;
  recipeVersion?: number;
  run?: string | number;
  onDiveIn: (initiative: DetectedInitiative) => void;
}): RenderSmartStep | undefined {
  if (args.recipeKey !== 'initiatives') return undefined;
  return makeInitiativesRenderSmartStep({
    recipeKey: args.recipeKey,
    recipeVersion: args.recipeVersion,
    run: args.run,
    onDiveIn: args.onDiveIn,
  });
}
